var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-btn",style:(_vm.styleSheet)},[_c('el-button',{style:(("width:" + _vm.width)),attrs:{"loading":_vm.loading,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }